<div class="tab-data-container">
	<ng-container *ngIf="!isLoadingLabels && !isLoadingForm && !isLoadingChangePlanData && !isLoadingCisChangePlanData">
		<div class="collapsable-header active" #changeDetail>
			<span>{{ labels.lbl_detalhamento_change }}</span>
			<span
				(click)="
					changeDetail.classList.contains('active')
						? changeDetail.classList.remove('active')
						: changeDetail.classList.add('active')
				"
				><fa-icon [icon]="changeDetail.classList.contains('active') ? icons.faTimes : icons.faAngleDown"></fa-icon
			></span>
		</div>

		<cpi-generic-form-gen
			class="collapsable-body"
			[ngClass]="{ active: changeDetail.classList.contains('active') }"
			[setGenericForm]="generalChangePlanForm"
			[boldLabel]="false"
			[triggerRequired]="triggerRequired"
			(valueTap)="setResponsiblesOnCi()">
		</cpi-generic-form-gen>

		<ng-container *ngIf="cisForm.length > 0">
			<div class="collapsable-header" #CMDB>
				<span class="title">CIS</span>
				<span (click)="CMDB.classList.contains('active') ? CMDB.classList.remove('active') : CMDB.classList.add('active')"
					><fa-icon [icon]="CMDB.classList.contains('active') ? icons.faTimes : icons.faAngleDown"></fa-icon
				></span>
			</div>
			<div class="collapsable-body" [ngClass]="{ active: CMDB.classList.contains('active') }">
				<ng-container *ngFor="let ci of cisForm">
					<span>{{ ci.ci.identification }}</span>
					<cpi-generic-form-gen [setGenericForm]="ci.form" [boldLabel]="false" [triggerRequired]="triggerRequired">
					</cpi-generic-form-gen>
				</ng-container>
			</div>
		</ng-container>

		<div class="collapsable-header" #preImplement>
			<span class="title">{{ labels.lbl_pre_implementacao }}</span>
			<span
				(click)="
					preImplement.classList.contains('active')
						? preImplement.classList.remove('active')
						: preImplement.classList.add('active')
				"
				><fa-icon [icon]="preImplement.classList.contains('active') ? icons.faTimes : icons.faAngleDown"></fa-icon
			></span>
		</div>
		<div class="collapsable-body" [ngClass]="{ active: preImplement.classList.contains('active') }">
			<cpi-generic-form-gen [setGenericForm]="preImplementForm" [boldLabel]="false" [triggerRequired]="triggerRequired">
			</cpi-generic-form-gen>
		</div>

		<div class="collapsable-header" #implement>
			<span class="title">{{ labels.lbl_implementacao }}</span>
			<span
				(click)="implement.classList.contains('active') ? implement.classList.remove('active') : implement.classList.add('active')"
				><fa-icon [icon]="implement.classList.contains('active') ? icons.faTimes : icons.faAngleDown"></fa-icon
			></span>
		</div>
		<div class="collapsable-body" [ngClass]="{ active: implement.classList.contains('active') }">
			<cpi-generic-form-gen [setGenericForm]="implementForm" [boldLabel]="false" [triggerRequired]="triggerRequired">
			</cpi-generic-form-gen>
		</div>

		<div class="collapsable-header" #posImplement>
			<span class="title">{{ labels.lbl_pos_implementacao }}</span>
			<span
				(click)="
					posImplement.classList.contains('active')
						? posImplement.classList.remove('active')
						: posImplement.classList.add('active')
				"
				><fa-icon [icon]="posImplement.classList.contains('active') ? icons.faTimes : icons.faAngleDown"></fa-icon
			></span>
		</div>
		<div class="collapsable-body" [ngClass]="{ active: posImplement.classList.contains('active') }">
			<cpi-generic-form-gen [setGenericForm]="posImplementForm" [boldLabel]="false" [triggerRequired]="triggerRequired">
			</cpi-generic-form-gen>
		</div>

		<div class="collapsable-header" #backout>
			<span class="title">Backout</span>
			<span (click)="backout.classList.contains('active') ? backout.classList.remove('active') : backout.classList.add('active')"
				><fa-icon [icon]="backout.classList.contains('active') ? icons.faTimes : icons.faAngleDown"></fa-icon
			></span>
		</div>
		<div class="collapsable-body" [ngClass]="{ active: backout.classList.contains('active') }">
			<cpi-generic-form-gen [setGenericForm]="backoutForm" [boldLabel]="false" [triggerRequired]="triggerRequired">
			</cpi-generic-form-gen>
		</div>

		<div class="collapsable-header" #testing>
			<span class="title">{{ labels.lbl_teste_e_validacao }}</span>
			<span (click)="testing.classList.contains('active') ? testing.classList.remove('active') : testing.classList.add('active')"
				><fa-icon [icon]="testing.classList.contains('active') ? icons.faTimes : icons.faAngleDown"></fa-icon
			></span>
		</div>
		<div class="collapsable-body" [ngClass]="{ active: testing.classList.contains('active') }">
			<cpi-generic-form-gen [setGenericForm]="testingForm" [boldLabel]="false" [triggerRequired]="triggerRequired">
			</cpi-generic-form-gen>
		</div>

		<div class="button-container">
			<div class="button" (click)="cleanFields()">{{ labels.lbl_limpar_valores }}</div>
			<div class="button" [ngClass]="{ disabled: isUpdatingChangePlan }" (click)="createChangePlan()" *ngIf="idChangePlan === ''">
				{{ labels.lbl_kb_criar }} {{ labels.lbl_chamado_plano_acao }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingChangePlan"></cpi-dot-bounce-loading-effect>
			</div>
			<div class="button" [ngClass]="{ disabled: isUpdatingChangePlan }" (click)="updateChangePlan()" *ngIf="idChangePlan !== ''">
				{{ labels.lbl_geral_atualizar }} {{ labels.lbl_chamado_plano_acao }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingChangePlan"></cpi-dot-bounce-loading-effect>
			</div>
		</div>
		<div class="button-container">
			<div class="button" (click)="exportToExcel()" *ngIf="idChangePlan !== ''">{{ labels.lbl_geral_exportar_dados }}</div>
		</div>
	</ng-container>

	<cpi-dot-bounce-loading-effect
		[color]="'var(--primary-color-1)'"
		*ngIf="isLoadingLabels || isLoadingForm || isLoadingChangePlanData || isLoadingCisChangePlanData"></cpi-dot-bounce-loading-effect>
</div>
